exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n.jobs img {\r\n  width: 100%;\r\n  height: auto;\r\n}\r\n\r\n.jobs {\r\n  background-color: #637560;\r\n  color: #f1f1f1;\r\n  height: auto;\r\n}\r\n\r\n.team h2 span{\r\n  background-color: #85baac;\r\n  color: #f1f1f1;\r\n  font-weight: 600;\r\n}\r\n\r\n.jobTitle p, .location p, .duties p, requires p, others p{\r\n  color: #4b525b;\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/anach/Desktop/tengtu-website/src/app/components/job/jobs/jobs.component.css
// module id = ../../../../../src/app/components/job/jobs/jobs.component.css
// module chunks = main